// src/components/AcceptableUsePolicy.tsx
import React from "react";
import { Box, Heading, Text, VStack, UnorderedList, ListItem, Link } from "@chakra-ui/react";
import { companyConfig } from "../config/company";

const AcceptableUsePolicy: React.FC = () => {
  const { operatorDescription, supportEmail, website, effectiveDate } = companyConfig;

  return (
    <Box maxW="860px" mx="auto" px={6} py={10}>
      <VStack align="start" spacing={6}>

        <Heading size="xl">Acceptable Use Policy</Heading>
        <Text fontSize="sm" color="gray.500">Effective date: {effectiveDate}</Text>

        <Text>
          This Acceptable Use Policy sets out the rules for using the platform operated
          by {operatorDescription}. By accessing our platform, you agree to comply with
          this policy.
        </Text>

        <Heading size="md">1. Permitted Use</Heading>
        <Text>
          You may use our platform solely for personal, non-commercial educational
          preparation purposes — specifically to practise for Australian school
          selection and standardised assessments. Each account is for the personal
          use of a single student.
        </Text>

        <Heading size="md">2. Prohibited Conduct</Heading>
        <Text>You must not:</Text>
        <UnorderedList spacing={2} pl={4}>
          <ListItem>Share, reproduce, or distribute any platform content, including questions, answers, or explanations, without our prior written consent.</ListItem>
          <ListItem>Share your account credentials or allow another person to use your account.</ListItem>
          <ListItem>Attempt to access another user's account or data.</ListItem>
          <ListItem>Use automated tools, bots, scrapers, or scripts to access or extract content from the platform.</ListItem>
          <ListItem>Attempt to circumvent any technical measures protecting our content or platform.</ListItem>
          <ListItem>Upload or transmit viruses, malware, or any malicious code.</ListItem>
          <ListItem>Use the platform in any way that could damage, disable, or impair its operation.</ListItem>
          <ListItem>Attempt to reverse-engineer, decompile, or derive source code from the platform.</ListItem>
          <ListItem>Use the platform to engage in any unlawful activity.</ListItem>
        </UnorderedList>

        <Heading size="md">3. Content Standards</Heading>
        <Text>
          Any content you submit through support requests or other communication channels
          must be lawful, respectful, and accurate. You must not submit false, misleading,
          defamatory, or offensive content.
        </Text>

        <Heading size="md">4. Enforcement</Heading>
        <Text>
          We reserve the right to suspend or terminate access to your account without
          notice if we determine that you have violated this policy. In serious cases,
          we may report conduct to relevant authorities. Where access is terminated due
          to a breach of this policy, refunds will not ordinarily be provided.
        </Text>

        <Heading size="md">5. Reporting Violations</Heading>
        <Text>
          If you become aware of any misuse of our platform, please report it to{" "}
          <Link href={`mailto:${supportEmail}`} color="blue.500">{supportEmail}</Link>.
        </Text>

        <Heading size="md">6. Changes</Heading>
        <Text>
          We may update this policy from time to time. Continued use of the platform
          after changes take effect constitutes acceptance.
        </Text>

        <Heading size="md">7. Contact</Heading>
        <Text>
          <Link href={`mailto:${supportEmail}`} color="blue.500">{supportEmail}</Link>
        </Text>

      </VStack>
    </Box>
  );
};

export default AcceptableUsePolicy;